module.exports = function (searchService, $stateParams, moveFocus) {
    return {
        scope: {
            multisearchItem: '='
        },
        restrict: 'EA',
        link(scope) {
            scope.search = searchService;
            scope.expandSearchResultsTypes = true;

            scope.isActiveMultisearchItem = function (item) {
                return item === $stateParams.searchTerm;
            };

            scope.shouldShowSearchResults = function (item) {
                return scope.isActiveMultisearchItem(item) && scope.expandSearchResultsTypes;
            };

            scope.clickMultisearchLink = function (multisearchItem) {
                if (scope.isActiveMultisearchItem(multisearchItem)) {
                    scope.expandSearchResultsTypes = !scope.expandSearchResultsTypes;
                } else {
                    moveFocus('#center-panel');
                    scope.expandSearchResultsTypes = true;
                    searchService.doMultisearch(multisearchItem, $stateParams.multisearchItems);
                }
            };

            scope.srText = function (item) {
                if (scope.isActiveMultisearchItem(item)) {
                    return scope.expandSearchResultsTypes ? 'Collapse search results for ' : 'Expand search results for ';
                }
                return 'Search for ';
            };
        },
        template: require('./search-multisearch-navigation-item-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-multisearch-navigation-item-directive.js
 **/